module.exports = __webpack_public_path__ + "static/media/1011640.26f89607.png";